export default __webpack_public_path__ + "static/media/delivery-man.546ebdbf.png";